<template>
  <div class="OnboardingInteractiveFormContainer">
    <OAuthCreateAccountInteractiveFormContainer
      v-if="displayContainer('createAccount')"
      product="auto_equity"
      @submit="onUserSubmitted"
    />
    <PersonaInfoInteractiveFormContainer
      v-if="displayContainer('personaInfo')"
      :display-steps="personaInfoSteps"
      @personaInfoSubmitted="onPersonaInfoSubmitted"
    />
    <AutoColdOfferInteractiveFormContainer
      v-if="displayContainer('coldOffer')"
      @submit="redirectToSimulatingPage"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import OAuthCreateAccountInteractiveFormContainer from '@/containers/forms/oauth/interactive/OAuthCreateAccountInteractiveFormContainer.vue'
import AutoColdOfferInteractiveFormContainer from '@/containers/forms/loans/auto/cold-offer/interactive/AutoColdOfferInteractiveFormContainer.vue'
import PersonaInfoInteractiveFormContainer from '@/containers/forms/persona/interactive/PersonaInfoInteractiveFormContainer.vue'
export default {
  name: 'AutoEquityInteractiveFormContainer',
  components: {
    OAuthCreateAccountInteractiveFormContainer,
    AutoColdOfferInteractiveFormContainer,
    PersonaInfoInteractiveFormContainer,
  },
  data() {
    return {
      currentContainerDisplayed: 'createAccount',
      personaInfoSteps: ['birth_date'],
    }
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
    }),
  },
  mounted() {
    this.gEventBus.emit('layout-unlogged:update-current-progress', 10)
  },
  methods: {
    ...mapActions({
      createFeedback: 'utils/feedback/createFeedback',
    }),
    onUserSubmitted() {
      this.currentContainerDisplayed = 'personaInfo'
      this.gEventBus.emit('layout-unlogged:update-current-progress', 33)
    },
    onPersonaInfoSubmitted() {
      this.currentContainerDisplayed = 'coldOffer'
      this.gEventBus.emit('layout-unlogged:update-current-progress', 66)
    },
    redirectToSimulatingPage(extraQuery = {}) {
      this.$router.push({
        path: '/simulando',
        query: {
          ...this.$route?.query,
          ...extraQuery,
          product: 'auto',
        },
      })
    },
    displayContainer(container) {
      return this.currentContainerDisplayed === container
    },
  },
}
</script>
<style lang="scss">
.OnboardingInteractiveFormContainer {
  position: relative;
  max-width: 600px;
  margin: 0 auto;
  height: 100%;

  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    z-index: 999;
    background: $color-white-high;

    .Spinner {
      margin-top: 80px;
    }
  }
}
</style>
